export default __webpack_public_path__ + "static/media/Matting_Dashboard_accessories_image.0dd92958.jpeg";